var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('el-container',[_c('Header'),_c('div',{staticClass:"main-content"},[_c('el-main',[_c('router-view')],1)],1),_c('a',{staticClass:"fixed-button",attrs:{"href":"#"}},[_vm._v("Boka nu")]),_c('el-footer',{staticClass:"footer",staticStyle:{"height":"100%"}},[_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }